export default __webpack_public_path__ + "static/media/13-cn.83594f31.webp";